import CartHeaderContent from './CartHeaderContent';
import { activeMenu, dispatchCloseMenuEvent } from '../../utils/menu';
import { getCartItemQuantityTotal } from '../../utils/cart';
import { Menu } from '../../types/menu';
import { RootState, useAppSelector } from '../../redux/store';
import { useActivateCart } from '../../utils/activateCart';
import { useEffect } from 'react';
import {
  AreaOne,
  AreaTwo,
  CartItemsInfo,
  CartItemsInfoWrapper,
  CartItemsLabel,
  CartLabel,
  CloseButton,
  CloseIcon,
  DropdownMenu,
} from './CartHeaderStyle';

export interface CartHeaderMobileContentProps {}

export default function CartHeaderMobileContent() {
  const cart = useAppSelector((state: RootState) => state.cart);
  const activateCart = useActivateCart();

  useEffect(() => {
    const subscription = activeMenu.subscribe((e) => {
      if (e === Menu.CART_MENU) {
        activateCart();
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const totalQuantity = getCartItemQuantityTotal(cart.cartItems);

  return (
    <DropdownMenu>
      <AreaOne>
        <CartItemsInfoWrapper>
          <CartItemsInfo>
            <CartLabel>Cart</CartLabel>
            <CartItemsLabel>
              ({totalQuantity} {totalQuantity === 1 ? 'item' : 'items'})
            </CartItemsLabel>
          </CartItemsInfo>
          <CloseButton onClick={() => dispatchCloseMenuEvent(Menu.CART_MENU)}>
            <CloseIcon></CloseIcon>
          </CloseButton>
        </CartItemsInfoWrapper>
      </AreaOne>
      <AreaTwo>
        <CartHeaderContent />
      </AreaTwo>
    </DropdownMenu>
  );
}
